import React from 'react'
import { Grid, Typography, makeStyles, Theme } from '@material-ui/core'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import { useFormikContext, Field } from 'formik'
import { FormattedMessage } from 'react-intl'
import {
  getSearchBoxHeaderText,
  SemiConfigFormValues,
  useProductFromQueryParam,
} from './ProductsConfiguration'
import ValidationErrors from '@src/routes/Configurators/validations/ValidationErrors'
import PageError from './PageError'

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    marginTop: theme.spacing(6),
  },
  instructions: {
    padding: theme.spacing(2, 0),
  },
}))
const SearchBox: React.FC = () => {
  const classes = useStyles()
  const product = useProductFromQueryParam()
  const formik = useFormikContext<SemiConfigFormValues>()
  const onSearchInputChange = async (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    formik.setFieldValue('searchData.searchKey', e.target.value, false)
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <PageError
          showError={formik.values.searchData.searchErrorMessage !== ''}
          rootStyle={{ marginTop: '24px' }}
        />
      </Grid>
      <Grid item xs={12} className={classes.title}>
        <Typography variant="h2">
          <FormattedMessage
            id="CONF_SEARCH_GENES"
            defaultMessage="Search Genes"
          />
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.instructions}>
        <Typography variant="body1">
          {getSearchBoxHeaderText(product)}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Field
          name={'search'}
          label={''}
          component={LiquidInputAdapter}
          required
          displayError={false}
          onChange={onSearchInputChange}
          multiline
          value={formik.values.searchData.searchKey}
          disabled={false}
          minRows={6}
          maxRows={6}
        />
      </Grid>
      {formik.values.searchData.searchErrorMessage !== '' && (
        <Grid item xs={12}>
          <ValidationErrors
            errors={[formik.values.searchData.searchErrorMessage]}
            configuratorsRedesign
          />
        </Grid>
      )}
    </Grid>
  )
}

export default SearchBox
